import { TranslationItemModel } from '@/api/BaseAPI.model'

type CategoryModel = {
  id?: string
  translations: TranslationItemModel[]
  dishSizeIds: string[]
}

type CategoriesResponseModel = CategoryModel[]

type IngredientModel = {
  id: string
  translations: TranslationItemModel[]
  allergenIds: string[]
  unitId: string
  quantity: number
  pricePerUnit: {
    unitId: string
    price: number
  }
}

type ReducedIngredientModel = {
  id: string
  unit: {
    id: string
    quantity: number
  }
}

type IngredientByDishSizeIdModel = {
  id: string
  ingredients: ReducedIngredientModel[]
}

type DishModel = {
  id?: string
  price: number
  priceToDishSizeId: {
    id: string
    price: number
  }[]
  ingredients: IngredientModel[]
  ingredientsByDishSizeId: IngredientByDishSizeIdModel[]
  menuNumber: number
  translations: TranslationItemModel[]
  dishToppingIds: string[]
  dishMenuTypeIds: string[]
  dishCategoryIds: string[]
  dishSizeIds: string[]
  allergenIds: string[]
  dietId: string | null
  spiceLevelId: string | null
}

type DishesResponseModel = DishModel[]

type OrderToppingModel = {
  id: string
  quantity: number
}

type OrderDishModel = {
  dishId: string
  sizeId?: string
  guestNumber: number
  extraNote: string
  toppings: OrderToppingModel[]
}

// New API shape (CreateOrderDto)
type CreateOrderToppingDto = {
  id: string
  quantity: number
}

type CreateOrderDishDto = {
  dishId: string
  sizeId?: string
  toppings: CreateOrderToppingDto[]
  extraNote?: string
}

type CreateOrderGuestDto = {
  guestNumber: number
  dishes: CreateOrderDishDto[]
}

type OrderPayloadModel = {
  tableIds: string[]
  guests: CreateOrderGuestDto[]
}

type OrderResponseModel = {
  tableIds: string[]
  dishes: OrderDishModel & { id: string }[]
}

enum QUERY {
  DISH_CATEGORIES = 'CATEGORIES',
  DISHES = 'DISHES'
}

export { QUERY }

export type {
  CategoryModel,
  CategoriesResponseModel,
  DishesResponseModel,
  OrderPayloadModel,
  OrderResponseModel,
  DishModel,
  CreateOrderGuestDto,
  CreateOrderDishDto,
  CreateOrderToppingDto
}
